import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';

import LoginMobile from "./LoginMobile.js";
import LoginDesktop from "./LoginDesktop.js";

import { AuthorizationCheck } from '../../utils/AuthorizationCheck';

const Home = ({auth}) => {
    
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new URLSearchParams();
            formData.append('email', email);
        
            const res = await axios.post('/auth/magic', formData.toString(), {
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              withCredentials: true
            });
            if (res.data.sent) {
                // Redirect to check email page
                window.location.href = '/check-your-email';
            } else {
                setStatus('Something unexpected happened.');
            }
          } catch (err) {
            console.error('Error sending magic link:', err);
            setStatus('Something went wrong. Please try again.');
          }
    };

    if ( AuthorizationCheck(auth, 'Private Beta', false) ) {
        return <Redirect to="/dashboard" />;
    }
    else {
        return (<>
            <Helmet>
              <meta name="robots" content="noindex, nofollow" />
              <title>Login - Elliot Koss</title>
            </Helmet>
            {/*MOBILE*/}
            <div className="d-block d-md-none">                
                <LoginMobile 
                    handleSubmit={handleSubmit}
                    email={email}
                    setEmail={setEmail}
                    status={status}
                />                
            </div>

            {/*TABLET*/}
            <div className="d-none d-md-block d-lg-none">                
                <LoginMobile 
                    handleSubmit={handleSubmit}
                    email={email}
                    setEmail={setEmail}
                    status={status}
                />                
            </div>

            {/*DESKTOP*/}
            <div className="d-none d-lg-block">      
                <LoginDesktop 
                    handleSubmit={handleSubmit}
                    email={email}
                    setEmail={setEmail}
                    status={status}
                />
            </div>
            
            
        </>   );  
    }
        
};

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(Home);
